import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import PageTracker from '../../../common/PageTrackerHelper'
import keycloak from '../../../common/Keycloak';

export default {
    name: 'B2Ddashboard',
    components: {
        BasicSelect,
        VueElementLoading
    },
    props: [],
    mixins:[PageTracker],
    data() {
        return{
            BusinessUnitsList: [],
            BusinessUnit: '',
            BusinessUnitItemObj: {text: ""},
            srLoader :'',
            loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            clientList: [],
            clientItemObj:{ value: "",text: ""},
            client: '',
            srList : [],
            srItemObj:{ value: "",text: ""},
            srId:'',
            LmUserToken: '',
            SRallocatedCount: 0,
            OfdCount: 0,
            deliveryCount: 0,
            NdrCount: 0,
            PODPendingCount: 0,
            PODConnectedCount: 0,
            CardLoader: false,
            userDataKey : '',
        }
    },

    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes  = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail =JSON.parse(plaintext);
        this.LmUserToken = window.localStorage.getItem('lmUserToken');
        this.username = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];

        this.loadSRList(this.userHubId)
        this.getClientList();
        this.getBusinessUnitList();
        this.getStatusWiseShipmentsCount();
    },

    methods: {
        redirectToB2bPortal(){
            
            if (keycloak.enableKavach) {
                window.open(apiUrl.b2bredirect_url);
            }else{

                let payload = {
                    token : this.LmUserToken
                }

                axios({
                    method: 'POST',
                    url: apiUrl.api_url + 'user/getredirecttob2burl',
                    data: payload
                })
                .then(result => {
                    if (result.data.code == 200) {
                        if(result.data.data.redirecturl){
                            window.open(result.data.data.redirecturl);
                        }
                        else{
                            this.$alertify.error("Redirect Url not received.!");
                        }
                    }
                    else if(result.data.code == 104){
                        // force Logout...
                        this.$router.push('/login');
                        this.$alertify.error('Your session has been expired, Please login again.!')
                    }
                    else{
                        this.$alertify.error(result.data.message);
                    }
                })
            }
        },

        loadSRList(hubid) {
            this.srLoader = this.loader;
            this.srList = [];
            if(hubid) {
                this.input = {
                    "HubId": hubid
                }
                let apiendpoint = "b2b/gethubsruser/list"
                if (keycloak.enableKavach) {
                    apiendpoint = 'user/migration/getb2bhubsrusers'
                }

                axios({
                    method: 'POST',
                    url: apiUrl.api_url + apiendpoint,
                    data: this.input
                })
                .then(result => {
                    if (result.data.data.code == 200) {
                        let srArrayList = result.data.data.results;
                        for (var i = 0; i < srArrayList.length; i++) {
                            this.srList.push({
                                value: srArrayList[i].userid,
                                text: `${srArrayList[i].srname} (${srArrayList[i].olddelveryuseroruserid}) (${srArrayList[i].userid})`
                            })
                        }
                    }
                    else {
                        this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
                    }
                    this.srLoader = '';
                }, error => {
                    this.srLoader = '';
                    console.error(error);
                })
            }
            else {
                this.$alertify.error("Current Hub Id not found.")
            }
        },

        getClientList(){
            this.srLoader = this.loader;
            this.clientList = [];
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'b2b/getclient/list',
                data: {}
            })
            .then(result => {
                if (result.data.code == 200) {
                    let ClientArrayList = result.data.data.data;
                    for (var i = 0; i < ClientArrayList.length; i++) {
                        this.clientList.push({
                            value: ClientArrayList[i].clientid,
                            text: `${ClientArrayList[i].clientshortname}`
                        })
                    }
                }
                else{
                    this.$alertify.error(result.data.message?result.data.message:'No Record found')
                }
                this.srLoader = '';
            }, error => {
                this.srLoader = '';
                console.error(error);
            })
        },

        getBusinessUnitList(){
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'b2b/get/businessunits',
                data: {}
            })
            .then(result => {
                if (result.data.code == 200) {
                    let BusinessUnitListArray = result.data.data.BusinessUnits;
                    for (var i = 0; i < BusinessUnitListArray.length; i++) {
                        this.BusinessUnitsList.push({
                            text: `${BusinessUnitListArray[i]}`
                        })
                    }
                }
                else{
                    this.$alertify.error(result.data.message?result.data.message:'No Record found')
                }
            })
        },

        getSRs(obj){
            this.srItemObj = obj,
            this.srId = parseInt(this.srItemObj.value),
            this.getStatusWiseShipmentsCount()
        },

        getBusinessUnits(obj){
            this.BusinessUnitItemObj = obj,
            this.BusinessUnit = obj.text,
            this.getStatusWiseShipmentsCount()
        },

        getclients(obj){
            this.clientItemObj = obj,
            this.client = this.clientItemObj.value,
            this.getStatusWiseShipmentsCount()
        },

        getStatusWiseShipmentsCount(){
            this.CardLoader = true;
            let payload = {
                "HubId": this.userHubId
            }
            if(this.client){
                payload.clientid = this.client
            }
            if(this.BusinessUnit){
                payload.businessunit = this.BusinessUnit
            }
            if(this.srId){
                payload.userid = this.srId
            }

            axios({
                method: 'POST',
                url: apiUrl.api_url + 'b2b/getstatuswise/shipmentcount',
                data: payload
            })
            .then(result => {
                if(result.data.code == 200){
                    this.SRallocatedCount = result.data.data.data.pendingallocation;
                    this.OfdCount = result.data.data.data.ofdcount;
                    this.deliveryCount = result.data.data.data.delivered;
                    this.NdrCount = result.data.data.data.ndr;
                    this.PODPendingCount = result.data.data.data.podpending;
                    this.PODConnectedCount = result.data.data.data.podconnected;
                }
                else{
                    this.$alertify.error(result.data.message?result.data.message:'No Record found')
                }
                this.CardLoader = false;
            }, error => {
                this.CardLoader = false;
                console.error(error);
            })
        },

        Reset(){
            this.srLoader = '';
            this.CardLoader = false,
            this.srItemObj = { value: "",text: ""};
            this.clientItemObj = { value: "",text: ""};
            this.BusinessUnitItemObj = {text: ""};
            this.BusinessUnit = '';
            this.srId = '';
            this.client = '';
            this.getStatusWiseShipmentsCount();
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/components/B2BCargoDashboard/B2BCargoDashboard.component.js